$(document).on('turbolinks:load', function(){
  if ($('.admin-editable-link').length) {
    $('.admin-editable-link').parent().addClass('admin-editable-link-parent');

    $('.modal').on('shown.bs.modal', function () {
      $('.admin-editable-link').addClass('d-none');
    });

    $('.modal').on('hidden.bs.modal', function () {
      $('.admin-editable-link').removeClass('d-none');
    });
  }
});